import React from 'react';
import classNames from 'classnames';
import i18next from 'i18next';
import PropTypes from 'prop-types';

import { package as PackagePropType } from 'lib/CustomPropTypes';

import ButtonHoverAnimation from 'components/ButtonHoverAnimation';
import Link from 'components/Link';
import TypeIcon from 'components/TypeIcon';
import TeasePicture from 'components/TeasePicture';
import Unibrow from 'components/Unibrow';
import Wrapper from 'components/packages/HeaderPackage/Wrapper';

import TitleLogo from 'components/TitleLogo';
import AIMS_FLAVORS from 'lib/aimsFlavors';

// TODO: [BENTO-12233] Temporarily leaving styles.css to handle grid styles.
// Will need refactor when solution for grid is implemented within new theming strategy
import styles from './styles.module.scss';

const responsiveFlavors = {
  s: AIMS_FLAVORS.FOCAL_60x60,
  xl: AIMS_FLAVORS.FOCAL_80x80,
};

class MagazineLead extends React.Component {
  down = false;

  lastX = 0;

  buffer = 10;

  static propTypes = {
    content: PackagePropType.isRequired,
    pkgClassName: PropTypes.string,
  };

  static defaultProps = {
    pkgClassName: 'pkg magazineLead',
  };

  getTease = (item) => {
    const { computedValues: { headline, url, unibrow }, id: contentId } = item;

    return (
      <div
        className="magazine-lead__tease"
        key={`magazineLeadItem-${contentId}`}
        data-contentid={contentId}
      >
        <Link to={url}>
          <div className="magazine-lead__tease-thumbnail">
            {this.image(item)}
            <TypeIcon
              type={item.type}
              additionalStyles="magazine-lead__tease-thumbnail__icon"
              radius
            />
          </div>
        </Link>
        <Unibrow
          className="magazine-lead__unibrow"
          unibrow={unibrow}
          size="h3"
        />
        <Link to={url}>
          <h2 className="magazine-lead__headline">{headline}</h2>
        </Link>
      </div>
    );
  }

  image = (item) => {
    const { type, metadata: { showTeaseImage } = {} } = item;

    if (showTeaseImage !== false) {
      return (
        <TeasePicture
          responsiveFlavors={responsiveFlavors}
          computedValues={item.computedValues}
          type={type}
          previewRedirect={false}
          retina
          placeholderColor={null}
        />
      );
    }
    return null;
  }

  handleMouseMove = (e) => {
    if (this.down) {
      const { left, right } = this.teaseWrapper.getBoundingClientRect();
      this.teaseWrapper.scrollLeft -= -this.lastX + (this.lastX = e.nativeEvent.clientX);
      if (this.lastX <= (left + this.buffer) || this.lastX >= (right - this.buffer)) {
        this.down = false;
      }
    }
    e.preventDefault();
  }

  handleMouseDown = (e) => {
    this.down = true;
    this.lastX = e.nativeEvent.clientX;
  }

  handleMouseUp = () => {
    this.down = false;
  }

  render() {
    const { content: { id, items, metadata }, pkgClassName } = this.props;
    const { title = i18next.t('On the show'), logoUrl, imageUrl } = metadata;
    return (
      <Wrapper id={id} className={classNames(pkgClassName, 'magazine-lead')}>
        {imageUrl && (
          <div className="magazine-lead__background" style={{ backgroundImage: `url(${imageUrl})` }} />
        )}
        <div className="magazine-lead__inner layout-grid-container">
          <div className={classNames(styles.content, 'magazine-lead__content')}>
            <div className="magazine-lead__title-wrapper">
              <h2 className="magazine-lead__title">
                <TitleLogo logoUrl={logoUrl} title={title} />
              </h2>
            </div>
            <div className={classNames(styles.outerTeaseWrapper, 'magazine-lead__outer-tease-wrapper')}>
              {/* eslint-disable jsx-a11y/no-static-element-interactions */}
              <div
                ref={(el) => { this.teaseWrapper = el; }}
                className="magazine-lead__teases"
                onMouseMove={this.handleMouseMove}
                onMouseDown={this.handleMouseDown}
                onMouseUp={this.handleMouseUp}
              >
                {items.filter((item) => item).map((item) => this.getTease(item))}
              </div>
              {/* eslint-enable jsx-a11y/no-static-element-interactions */}
            </div>
            <div className="magazine-lead__see-all-wrapper">
              {metadata.seeAllUrl && (
                <ButtonHoverAnimation
                  size="small"
                  type="link"
                  url={metadata.seeAllUrl}
                  additionalClasses="magazine-lead__see-all-btn"
                  title={metadata.seeAllText || i18next.t('See All From The Show')}
                />
              )}
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

export default MagazineLead;
